export const ROLE_TYPES = {
  BORROWER: 'borrower',
  NON_BORROWER: 'nonBorrower',
  INTERNAL: 'internal',
};
